/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MusdV3SusdBalancer } from "../MusdV3SusdBalancer";

export class MusdV3SusdBalancer__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<MusdV3SusdBalancer> {
    return super.deploy(overrides || {}) as Promise<MusdV3SusdBalancer>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MusdV3SusdBalancer {
    return super.attach(address) as MusdV3SusdBalancer;
  }
  connect(signer: Signer): MusdV3SusdBalancer__factory {
    return super.connect(signer) as MusdV3SusdBalancer__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MusdV3SusdBalancer {
    return new Contract(address, _abi, signerOrProvider) as MusdV3SusdBalancer;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "bAssets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "funderAccount",
        type: "address",
      },
    ],
    name: "balanceSusd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
